import React, { useEffect, useState } from "react";
import "./WizardStepsStyle.scss";


const WizardSteps = ({ stepNo, totalStep, failedStep, onStepClick }) => {
  const [step, setStep] = useState(stepNo);

    useEffect(() => {
    setStep(stepNo);
  }, [stepNo]);

  return (
    <div className="wizard">
      {/* Dynamic Step Indicators */}
      <div className="wizard-steps">
        {[...Array(totalStep)].map((_, index) => {
          let className = "step";
          const stepIndex = index + 1;

          if (stepIndex === failedStep) {
            className += " failed";
          } else if (step > stepIndex) {
            className += " completed";
          } else if (step === stepIndex) {
            className += " active";
          }

          const isClickable = className.includes("completed") && typeof onStepClick === "function";
          return (
            <div
              key={index}
              className={className}
              role={isClickable ? "button" : undefined}
              tabIndex={isClickable ? 0 : undefined}
              onClick={isClickable ? () => onStepClick(stepIndex) : undefined}
              onKeyDown={
                isClickable
                  ? (e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        onStepClick(stepIndex);
                      }
                    }
                  : undefined
              }
            >
              {step <= stepIndex ? stepIndex : ""}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WizardSteps;

